import { InjectionToken } from '@angular/core';
import { ProfileDataConfig } from './profile-data.module';

export const PROFILE_DATA_CONFIG = new InjectionToken<ProfileDataConfig>(
  'profile-data-config',
);
